import { Condition } from '../model/rule-engine.model';

export abstract class AbstractCondition<T> implements Condition<T> {
  abstract type: string;
  abstract params: any;
  result: boolean = false;
  or?: Condition<T>[] = null;

  constructor(params: Pick<Condition<T>, 'params' | 'result' | 'or'>) {
    const { result = false } = params;
    Object.assign(this, params, { result });
  }

  abstract assert(context: T): boolean;
}
